module.exports = __webpack_public_path__ + "files/cc47635427ac2b91bb4972ddde8b9df4.png";